//components
import Nav from './components/Nav';
import HeroSection from './components/HeroSection';
import Features from './components/Features';
import Socials from './components/Socials';

function App() {
  return (
    <div className="bg-gradient-to-br from-RoyalGreen px-4 to-RoyalBrown min-h-screen  font-mooli">
      <HeroSection/>
      <Features/>
      <Nav />
      <Socials/>
    </div>
  );
}

export default App;
